import axios from '@/libs/api.request';
import {
    PRODUCT_APPROVAL_NO,
    PRODUCT_APPROVAL_YES,
    PRODUCT_APPROVAL_INREVIEW
} from '@/view/product-management/product-management/ProductApproveDefine';
import { getProductList } from '@/api/modules/product-management/product-management';

export const getProductApproveList = data => {
    return axios.request({
        url: 'api/productManagement/productApprove/getProductApproveList',
        data: data,
        method: 'post'
    });
};

export const getUnapprovedProductList = data => {
    data.filters.enable = true;
    const findCondition = data.filters.conditions.find(c => c.name === 'productApproval');
    if (findCondition) {
        findCondition.value = PRODUCT_APPROVAL_NO;
    }
    else {
        data.filters.conditions.push({
            name: 'productApproval',
            type: 'eq',
            value: PRODUCT_APPROVAL_NO
        });
    }

    return getProductList(data);
};

export const getApprovedProductList = data => {
    data.filters.enable = true;
    const findCondition = data.filters.conditions.find(c => c.name === 'productApproval');
    if (findCondition) {
        findCondition.value = JSON.stringify([PRODUCT_APPROVAL_YES, PRODUCT_APPROVAL_INREVIEW]);
    }
    else {
        data.filters.conditions.push({
            name: 'productApproval',
            type: 'in',
            value: JSON.stringify([PRODUCT_APPROVAL_YES, PRODUCT_APPROVAL_INREVIEW])
        });
    }

    data.order.enable = true;
    const findCurSalePriceStatus = data.order.conditions.find(o => o.name === 'productCurSalePriceStatus');
    if (!findCurSalePriceStatus) {
        data.order.conditions.push({
            name: 'productCurSalePriceStatus',
            type: 'asc'
        });
    }

    const findPreSalePriceStatus = data.order.conditions.find(o => o.name === 'productPreSalePriceStatus');
    if (!findPreSalePriceStatus) {
        data.order.conditions.push({
            name: 'productPreSalePriceStatus',
            type: 'asc'
        });
    }

    return getProductList(data);
};

export const saveProductApprove = data => {
    return axios.request({
        url: 'api/productManagement/productApprove/saveProductApprove',
        data: data,
        method: 'post'
    });
};

export const getProductApproveDetail = productApproveRecordUuid => {
    return axios.request({
        url: 'api/productManagement/productApprove/getProductApproveDetail',
        data: { productApproveRecordUuid },
        method: 'post'
    });
};

export const getProductDescriptiveInformation = productUuid => {
    return axios.request({
        url: 'api/productManagement/product/getProductDescriptiveInformation',
        data: { productUuid },
        method: 'post'
    });
};

export const saveProductDescriptiveInformation = data => {
    return axios.request({
        url: 'api/productManagement/product/saveProductDescriptiveInformation',
        data: data,
        method: 'post'
    });
};

export const saveProductListDescriptiveInformation = data => {
    return axios.request({
        url: 'api/productManagement/product/saveProductListDescriptiveInformation',
        data: data,
        method: 'post'
    });
};

export const saveProductListDescriptiveInformationSingleAttribute = data => {
    return axios.request({
        url: 'api/productManagement/product/saveProductListDescriptiveInformationSingleAttribute',
        data: data,
        method: 'post'
    });
};

export const updateProductApproveResult = data => {
    return axios.request({
        url: 'api/productManagement/productApprove/updateProductApproveResult',
        data: data,
        method: 'post'
    });
};
